import { render, staticRenderFns } from "./SendDefaultContent.vue?vue&type=template&id=d09893f6&scoped=true"
import script from "./SendDefaultContent.vue?vue&type=script&lang=js"
export * from "./SendDefaultContent.vue?vue&type=script&lang=js"
import style0 from "./SendDefaultContent.vue?vue&type=style&index=0&id=d09893f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09893f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d09893f6')) {
      api.createRecord('d09893f6', component.options)
    } else {
      api.reload('d09893f6', component.options)
    }
    module.hot.accept("./SendDefaultContent.vue?vue&type=template&id=d09893f6&scoped=true", function () {
      api.rerender('d09893f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/managePackages/components/dialog/SendDefaultContent.vue"
export default component.exports